import React from "react";
import { Box, Grid, Typography, Card, CardContent } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Wifi, DirectionsBusFilled, LocalOffer, EventAvailable } from "@mui/icons-material";

const featureKeys = [
  { key: "modernFleet", icon: DirectionsBusFilled },
  { key: "wifi", icon: Wifi },
  { key: "prices", icon: LocalOffer },
  { key: "quickBooking", icon: EventAvailable },
];

const FeaturesSection = () => {
  const { t } = useTranslation("common");
  return (
    <Box>
      <Typography
        variant="h5"
        fontWeight="bold"
        textAlign="center"
        mb={0.5}
        color="text.primary"
        sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
      >
        {t("features.whyUs")}
      </Typography>
      <Typography
        variant="body1"
        textAlign="center"
        color="text.secondary"
        mb={1.5}
      >
        {t("features.subtitle")}
      </Typography>

      <Grid container spacing={1.5}>
        {featureKeys.map(({ key, icon: Icon }, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              variant="outlined"
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                borderRadius: "10px",
                border: "1px solid",
                borderColor: "divider",
                transition: "transform 0.3s, box-shadow 0.3s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.15)",
                },
              }}
            >
              <CardContent
                sx={{
                  p: 3,
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  flexGrow: 1,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mb: 2,
                    color: "secondary.main",
                  }}
                >
                  <Icon sx={{ fontSize: 48 }} />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    mb: 1.5,
                    color: "text.primary",
                  }}
                >
                  {t(`features.${key}`)}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    fontSize: "0.875rem",
                  }}
                >
                  {t(`features.${key}Desc`)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FeaturesSection;
